//============================================================================
// Name        : shipments.ts
// Purpose     : Implement shipments and transfers page
// Created     : 2021-04-13
// Author      : Alireza Mohagheghi
// Copyright   : Copyright 2021 Senitron Corporation. All rights reserved.
//============================================================================

import {InitPage} from "../index";

class PalletBuild {
    init() {
        const advancedSearchDiv = $("#advanced_search");
        advancedSearchDiv.on("click", (e) => {
            if (e.target.classList.value == "collapsed" || e.target.classList.value == "") {
                advancedSearchDiv.addClass("expanded");
            } else {
                advancedSearchDiv.removeClass("expanded");
            }
        });
    }
}

export function LoadPage() {
    InitPage("cartons", () => {
        const palletBuild = new PalletBuild();
        palletBuild.init();
    });
}
